"use client";

import styles from "../../Supplier Ratings/css/supplierRatings.module.css";
import Button from "../../../../components/Button";
import Dropdown from "../../../../components/Dropdown";
import { Star } from "lucide-react";

export default function RatingModal({
  showRatingModal,
  setShowRatingModal,
  ratingSupplier,
  setRatingSupplier,
  ratingForm,
  setRatingForm,
  ratingEditIndex,
  supplierOptions,
  onSave
}) {
  if (!showRatingModal) return null;

  return (
    <div className={styles.ratingModal}>
      {ratingSupplier && (<h2 className={styles.ratingsTitle}>{ratingSupplier} Rating</h2>)}
      {ratingEditIndex === -1 && (
        <div className={styles.ratingField}>
          <div style={{ width: '100%' }}>
            <Dropdown
              options={supplierOptions}
              value={ratingSupplier || ""}
              onChange={(v) => setRatingSupplier(v)}
              placeholder="Supplier"
              className={styles.smallDropdown}
            />
          </div>
        </div>
      )}
      <div className={styles.starsPanel}>
        {[
          { key: "quality", label: "Quality" },
          { key: "reliability", label: "Reliability" },
          { key: "delivery", label: "Delivery" },
          { key: "cost", label: "Cost" },
          { key: "compliance", label: "Compliance" },
          { key: "customerService", label: "Customer Service" },
        ].map((row) => (
          <div key={row.key} className={styles.starRow}>
            <span className={styles.starLabel}>{row.label}</span>
            <div className={styles.starControls}>
              {[1,2,3,4,5].map((n) => (
                <button
                  key={n}
                  type="button"
                  className={styles.starBtn}
                  onClick={() => setRatingForm((prev) => ({ ...prev, [row.key]: n }))}
                  aria-label={`${row.label} ${n} star`}
                >
                  <Star
                    size={18}
                    fill={ratingForm[row.key] >= n ? "#f59e0b" : "none"}
                    color={ratingForm[row.key] >= n ? "#f59e0b" : "#cbd5e1"}
                  />
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.modalActionsCenter}>
        <Button
          variant="primary"
          className={styles.saveBtn}
          noHover
          onClick={onSave}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
